import styles from './SupplierDetail.css'
import SupplierForm from './SupplierForm'
import {connect} from 'react-redux'
import {submitFormCreate, submitFormUpdate} from 'actions/inventory/supplier'

class SupplierDetail extends React.Component {
  render () {
    return (<div className={styles.wrapper}>
      <SupplierForm onSubmit={this._onSubmit} />
    </div>)
  }

  _onSubmit = (values) => {
    const {dispatch, suppliers} = this.props
    if (values.id) {
      dispatch(submitFormUpdate(values.id, {supplier: values}, suppliers))
    } else {
      dispatch(submitFormCreate({supplier: values}, suppliers))
    }
  }
}

function mapStateToProps (state) {
  const {suppliers} = state.inventory.supplier
  return {
    suppliers
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(SupplierDetail)



// WEBPACK FOOTER //
// ./app/pages/Inventory/Supplier/SupplierDetail/SupplierDetail.js